<template>
<div id="container" class="container zirkusgeschichten">
  <div class="fullscreen_background">
    <img src="/static/assets/zirkusgeschichten/Hintergrund_2860.jpg" />
  </div>

  <sterne :amount="100" :size="6" :speed="0.5" :wind="0" :opacity="1" :swing="1" :image="sternchen" :zIndex="null" :resize="true" color="#fff" />
  <top-logo />
  <stoppuhr />
  <lautsprecher />
  <top-menu />
  <copyright />
      <hintergrundbutton />

  <div class="spotlight1">
    <img class="img" src="/static/assets/zirkusgeschichten/Zirkusdirektor_Dubix_2880zu1620_02-01.png" />
  </div>
	<div class="spotlight2">
    <img class="img" src="/static/assets/zirkusgeschichten/Zirkusdirektor_Dubix_2880zu1620_03-01.png" />
  </div>
	<div class="spotlight3">
    <img class="img" src="/static/assets/zirkusgeschichten/Zirkusdirektor_Dubix_2880zu1620_04-01.png" />
  </div>
  <div class="gigi z30">
    <img class="img" src="/static/assets/zirkusgeschichten/Gigi.png" />
  </div>
  <!--div class="hui z30">
        <img class="img" src="/static/assets/zirkusgeschichten/Hui.png" />
    </div-->
  <div class="zampano z30">
   <!-- <img class="img" src="/static/assets/zirkusgeschichten/Zampano.png" /> -->
	  <div class="zampano_animation"></div>
  </div>
  <div class="globus z30">

  </div>
   <div class="kerze z30">

  </div>
  <div class="libero z30">
    <img class="img" src="/static/assets/zirkusgeschichten/Libero.png" />
  </div>
  <div class="trompeter z30">
    <img class="img" src="/static/assets/zirkusgeschichten/Trompeter.png" />
  </div>
  <div class="jongleur z30">
   <!-- <img class="img" src="/static/assets/zirkusgeschichten/Jongleur.png" /> -->
	  <div class="jongleur_animation"></div>
  </div>
  <div class="hugi z30">
    <img class="img" src="/static/assets/zirkusgeschichten/Hugi.png" />
  </div>
  <div class="dubix z30">
    <img class="img " src="/static/assets/zirkusgeschichten/Dubix.png" />
  </div>
  <div class="zampana z30">
    <img class="img " src="/static/assets/zirkusgeschichten/Zampana.png" />
  </div>
  <!-- <div class="moebel_vorne z40">
        <img class="img" src="/static/assets/zirkusgeschichten/Moebel_vorne.png" />
    </div> -->

  <!-- <router-link to="/maerchengeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/zirkusgeschichten/Pfeil.png" />
    </router-link> -->
  <!--div class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zirkusgeschichten/Pfeil-1.png" />
    </div-->

  <router-link to="/djgeschichten" tag="div" class="pfeil_links_big z50 pointer">
    <img class="img" src="/static/assets/zirkusgeschichten/Pfeil.png" />
  </router-link>
  <router-link tag="div" to="skigeschichten" class="pfeil_rechts_big z50 pointer">
    <img class="img" src="/static/assets/zirkusgeschichten/Pfeil-1.png" />
  </router-link>

  <div class="geschichte z45">
    <div class="inner">
      <img src="/static/assets/zirkusgeschichten/Zirkusdirektor Dubix.png" usemap="#geschichte-map">
      <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichte_3_Zirkusdirektor_Dubix.mp3" jsonurl="/static/assets/geschichten/dubix_28_11.timings.json" content=".zirkusgeschichten" target="zirkusgeschichten_target" />
      <vuescrollbar tag="div" class="fliesstext" id="zirkusgeschichten_target">
        <p>Trompeter Tom blies seine Lieblingsmelodie, endlich sollte die Vorstellung beginnen. Zirkusdirektor Dubix hatte die erste Nummer angesagt. Hochseil und Netz waren gespannt und bald würde Seiltänzerin Gigi Grazilo ihre Balancierkünste zeigen. Sie tanzte und fuhr Einrad über das Seil, ja sie machte sogar einen Salto rückwärts auf dem Seil! Bravo! Bravo! </p>
        <p>Das Publikum war begeistert und applaudierte kräftig. Glücklich verbeugte sich Gigi Grazilo, winkte den Zuschauern und warf Kusshändchen.</p>
        <p>Schon sagte Zirkusdirektor Dubix die nächste Nummer an. Die weltbesten Trapezkünstler Zampano und Zampana sollten auftreten. Stattdessen raste jedoch ein kleiner weißer Hund durchs Publikum, verfolgt von einer laut schimpfenden Person mit struppigem rotem Haar. Das waren Libero Fantastico und Clown Hugi! Plötzlich blieb das Hündchen sitzen und in dem Moment, als sein Verfolger es schnappen wollte, setzte es seine Flucht fort. Clown Hugi landete auf seiner dicken roten Nase, die dabei laut hupte. Ha, ha, ha! Das Publikum lachte schallend und weiter ging die lustige Jagd. Erst als Clown Hugi sich in die Mitte der Manege setzte, aus seiner weiten Hose ein winziges Akkordeon zog und wunderschön zu spielen begann, gab Libero Fantastico auf und legte sich ihm zu Füßen. Vergnügt verabschiedeten die Zuschauer die beiden.</p>
        <p>Wieder betrat Zirkusdirektor Dubix die Manege: „Meine Damen und Herren, hier sind sie endlich: Zampano und Zampana!“ Hoch oben schaukelten schon die beiden Luftakrobaten und nun begannen sie, zwischen den Trapezen schnell hin und her zu fliegen. Das Publikum konnte gar nicht mehr aufhören zu klatschen. Da gab Zirkusdirektor Dubix bekannt: „Erleben Sie nun eine einmalige Weltpremiere! Zampana wird mit verbundenen Augen zu Zampano springen und er wird sie am Trapez hängend auffangen.“ „Boah!“ Die Zuschauer wollten es nicht glauben, doch schon verband sich Zampana die Augen, stellte sich auf das Trapez und holte für ihren Flug Schwung. Im Zirkus war es mucksmäuschenstill. Doch, ach! Zampana verfehlte die Hände Zampanos. „Nein!“, schrie das Publikum, doch Zampana landete mitten im Sicherheitsnetz. Enttäuscht nahm sie sich die Binde von den Augen und wer genau hinsah, konnte Tränen in ihren Augen sehen.</p>
        <p>Da rief ihr Zirkusdirektor Dubix aufmunternd zu: „Zampana, probiere es einfach noch einmal! Ich habe auch eine ganz, ganz tolle Überraschung für dich!“ Zampano und das Publikum klatschten und spornten sie an. Also kletterte sie über die Strickleiter zurück auf ihr Trapez und verband sich erneut die Augen. Das Klatschen hörte schlagartig auf, kein Laut war mehr zu hören. Zampana holte Schwung, sprang und flog — hurra! — direkt in Zampanos Arme! Das Publikum jubelte und Trompeter Tom spielte gleich nochmal seine Lieblingsmelodie. Die beiden Flugakrobaten machten einen Freudensprung ins Netz, verließen es mit einem Purzelbaum und verneigten sich überglücklich.</p>
        <p>Zirkusdirektor Dubix aber war hinter dem Vorhang verschwunden. Als er wieder auftauchte, hielt er die versprochene Überraschung, ein dickes Buch, in seinen Händen. Er überreichte es der strahlenden Zampana. Dann wandte er sich ans Publikum: „Sie müssen wissen, für uns Zirkusleute sind Bücher so spannend und lustig wie Zirkus. Wir lieben Bücher sehr und finden: </p>
        <p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
  </div>

</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */
/* eslint no-unused-vars: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Copyright from '@/components/Copyright.vue'
import Snowf from 'vue-snowf'
import Lautsprecher from '@/components/Lautsprecher.vue'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'zirkusgeschichten',
  data () {
    return {
      who: 'zirkusgeschichten',
      sternchen: '/static/assets/zirkusgeschichten/sternchen.png',
      audioposition: 0
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'sterne': Snowf,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)
    var self = this
    setTimeout(function () {
      var muted = (typeof self.$root.muted !== 'undefined' ? self.$root.muted : false)
      try {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      window.currentAudioX = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Dubix_Titel_A1902.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }

      window.hintergrundSound = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_zirkuser_Atmo.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined'?   window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e) {
        window.bgsounddisabled = true
      }


    }, 1000);
  },
  beforeDestroy () {
/*    if (window.currentAudio !== 'undefined') {
      window.currentAudio.pause()
    }
    try {
      window.hintergrundSound.pause()
    } catch(e) {}
*/    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
      console.log('hintergrundsound nicht aktiv')
    }

  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

/* zirkusgeschichten */

.zirkusgeschichten {
  position: absolute;
  width: 1920px;
  height: 1080px;
  top: 0;
}

.zirkusgeschichten .himmel {
  display: block !important;
}

.zirkusgeschichten .geschichte {
  position: absolute;
    top: 144px;
    left: 50%;
}

.zirkusgeschichten .geschichte .inner {
  position: relative;
}



.zirkusgeschichten .pfeil_links_big {
  position: absolute;
  left: 1vw;
  top: 40%;
}

.zirkusgeschichten .pfeil_rechts_big {
  position: absolute;
  right: 1vw;
  top: 40%;
}

.zirkusgeschichten .moebel_vorne {
  position: absolute;
  bottom: 0;
  left: 0;
}

.zirkusgeschichten .miss_witch {
  position: absolute;
  /* top: 50%; left: 21%; */
  top: 47%;
  left: 23%;
}

.zirkusgeschichten .hugi {
  position: absolute;
  opacity:0;
  animation: hugi_erscheint 1s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}

@keyframes hugi_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.zirkusgeschichten .jongleur {
  opacity:0;
  animation: jongleur_erscheint 1.5s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}

@keyframes jongleur_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
	.zirkusgeschichten .trompeter {
  opacity:0;
  animation: trompeter_erscheint 2s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}
@-webkit-keyframes wippen /* Safari and Chrome */ {
  0% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  25% {
    -webkit-transform: rotateX(15deg);
    -o-transform: rotateX(15deg);
    transform: rotateX(15deg);
  }
  50% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  75% {
    -webkit-transform: rotateX(-15deg);
    -o-transform: rotateX(-15deg);
    transform: rotateX(-15deg);
  }
  100% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
}
@keyframes wippen {
  0% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  25% {
    -webkit-transform: rotateX(15deg);
    -o-transform: rotateX(15deg);
    -moz-transform: rotateX(15deg);
    transform: rotateX(15deg);
  }
  50% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  75% {
    -webkit-transform: rotateX(-15deg);
    -o-transform: rotateX(-15deg);
    -moz-transform: rotateX(-15deg);
    transform: rotateX(-15deg);
  }
  100% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
}
.zirkusgeschichten .spotlight1 img{animation: spotlight1_erscheint 3s ease-out; animation-delay: 0s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes spotlight1_erscheint {
    0% {margin-left: 1000px; opacity:0;}
    50% { opacity:0.5;}
    100% {margin-left: 0px; opacity:1;}
}
	.zirkusgeschichten .spotlight2 img{animation: spotlight2_erscheint 3s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes spotlight2_erscheint {
    0% {margin-left: -1000px; opacity:0;}
    50% { opacity:0.5;}
    100% {margin-left: 0px; opacity:1;}
}
		.zirkusgeschichten .spotlight3 img{animation: spotlight2_erscheint 2s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes spotlight3_erscheint {
    0% {margin-left: -1000px; opacity:0;}
    50% { opacity:0.5;}
    100% {margin-left: 0px; opacity:1;}
}
.zirkusgeschichten .wippen {
  -webkit-animation: wippen 4s linear infinite;
  -moz-animation: wippen 4s linear infinite;
  -ms-animation: wippen 4s linear infinite;
  -o-animation: wippen 4s linear infinite;
  animation: wippen 4s linear infinite;
}
@keyframes trompeter_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.zirkusgeschichten .libero {
  position: absolute;
    top: 44.5%;
    right: 51.3%;
}

.zirkusgeschichten .libero {
  animation: libero_erscheint 0.5s ease-out;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes libero_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.zirkusgeschichten .zampano {
  position: absolute;
    top: -24%;
    left: 26%;
}

.zirkusgeschichten .zampano img {
  animation-delay: 8s;
  animation: zampano_erscheint 1s;
  transform-origin: bottom center;
}

@keyframes zampano_erscheint {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  80% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.zirkusgeschichten .fliesstext {
  bottom: 28%;
  left: 9.5%;
  width: 79%;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 450px;
  padding-right: 15px;
}

.zirkusgeschichten div.fliesstext>span {
  margin-right: 8px !important;
  float: left !important;
}

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px #ac8a69;
  box-shadow: inset 0 0 0px #ac8a69;
  -webkit-border-radius: 0;
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #ac8a69;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #ac8a69;
}

::-webkit-scrollbar-button {
  background: none;
}

::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}

::-webkit-scrollbar-button:vertical:decrement {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_up.png);
  background-position: 0px 0px;
}

::-webkit-scrollbar-button:vertical:increment {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_do.png);
  background-position: 0px 0px;
}

.snowf-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 150% !important;
  height: 150% !important;
  left: -25% !important;
  z-index: 30 !important;
}

.dubix_animation {
  width: 320px;
  height: 320px;
  background: url('/static/assets/zirkusgeschichten/01_zirkusmeister_Dubix.png') top center;
  transform: scale(1);
  margin-top: -25px;
  margin-left: -50px;
}
.zirkusgeschichten .gigi {
    position: absolute;
}
@keyframes play_dubix {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -1600px;
  }
  100% {
    background-position: 0 -1600px;
  }
}

.globus {
  width: 350px;
  height: 350px;
  background: url('/static/assets/zirkusgeschichten/01_Globus_1.png') top center;
  animation-delay: 2s;
  animation: play_globus 4s steps(6) infinite;
  transform: scale(0.465);
  top: -87px;
  left: 849px;
  position: absolute;
}

@keyframes play_globus {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -2100px;
  }
  100% {
    background-position: 0 -2100px;
  }
}
.kerze {
    width: 380px;
    height: 529px;
    background: url(/static/assets/zirkusgeschichten/01_Kerze_1.png) top center;
    animation: play_kerze 2s steps(8) infinite;
    transform: scale(0.26);
    top: 533px;
    left: 728px;
    position: absolute;
}

@keyframes play_kerze {
  0% {
    background-position: 0 0px;
  }
  100% {
    background-position: 0 -4232px;
  }
}
.dubix.z30 {
  position: absolute;
    top: 595px;
    left: 710px;
}
.zirkusgeschichten .hugi {
    position: absolute;
    top: 513px;
    left: 219px;
}
	.zirkusgeschichten .jongleur {
    position: absolute;
    top: 465px;
    left: 380px;
}
.zirkusgeschichten .trompeter {
    position: absolute;
    top: 533px;
    left: 560px;
}
	.zirkusgeschichten .spotlight1, .zirkusgeschichten .spotlight2, .zirkusgeschichten .spotlight3 {
    position: absolute;
    top: -26%;
    left: -25%;
}
	.zirkusgeschichten .zampana {
    position: absolute;
    top: 67%;
    left: 20%;
}
.dubix {
  transform-origin: bottom center;
}
.jongleur_animation {
  width: 172px;
  height: 220px;
  background: url('/static/assets/zirkusgeschichten/jongleur_animation.png') top center;
  animation-delay: 2s;
  animation: jongleur_animation 4s steps(8) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes jongleur_animation {
  100% {
    background-position: 0 -1760px;
  }
}
	.zampano_animation {
  width: 610px;
  height: 682px;
  background: url('/static/assets/zirkusgeschichten/zampano_animation.png') top center;
  animation-delay: 2s;
  animation: zampano_animation 3s steps(10) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes zampano_animation {
  100% {
    background-position: 0 -6820px;
  }
}
.hovering {
  -webkit-animation: hovering 8s ease-in-out infinite;
  -moz-animation: hovering 8s ease-in-out infinite;
  -ms-animation: hovering 8s ease-in-out infinite;
  -o-animation: hovering 8s ease-in-out infinite;
  animation: hovering 8s ease-in-out infinite;
}

@-webkit-keyframes hovering
/* Safari and Chrome */

  {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@keyframes hovering {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  /* 25% {
    -ms-transform: translate(-20px,20px);
    -moz-transform: translate(-20px,20px);
    -webkit-transform: translate(-20px,20px);
    -o-transform: translate(-20px,20px);
    transform: translate(-20px,20px);
  }
 */
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  /*  75% {

    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
*/
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

span {
  font-family: FrozenMemory;
}
</style>



// WEBPACK FOOTER //
// src/components/Zirkusgeschichten.vue